/**
 * Re-initialize Yotpo v3 widgets after deferred section/block HTML is injected
 * (e.g. cx-container lazy loading). Yotpo only scans the DOM on initial loader run.
 *
 * @see https://support.yotpo.com/docs/loading-yotpo-with-ajax
 */

/** @type {number} */
const MAX_INIT_ATTEMPTS = 40;

/** @type {number} */
const INIT_RETRY_MS = 250;

/**
 * @param {ParentNode} root
 * @returns {boolean}
 */
function hasYotpoWidgetInstance(root) {
  return Boolean(root.querySelector('.yotpo-widget-instance'));
}

/**
 * @param {ParentNode} root
 */
function initYotpoWidgetsIn(root) {
  if (!hasYotpoWidgetInstance(root)) return;

  let attempt = 0;

  const tryInit = () => {
    const widgetsContainer = /** @type {{ initWidgets?: () => void } | undefined} */ (
      globalThis.yotpoWidgetsContainer
    );

    if (widgetsContainer?.initWidgets) {
      widgetsContainer.initWidgets();
      return;
    }

    const legacyYotpo = /** @type {{ initWidgets?: () => void } | undefined} */ (globalThis.yotpo);
    if (legacyYotpo?.initWidgets) {
      legacyYotpo.initWidgets();
      return;
    }

    attempt += 1;
    if (attempt < MAX_INIT_ATTEMPTS) {
      window.setTimeout(tryInit, INIT_RETRY_MS);
    }
  };

  tryInit();
}

/**
 * @param {Event} event
 */
function onLazyContentLoaded(event) {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;
  initYotpoWidgetsIn(target);
}

/**
 * @param {Event} event
 */
function onSectionLoad(event) {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;
  initYotpoWidgetsIn(target);
}

document.addEventListener('lazy-content-section:loaded', onLazyContentLoaded);
document.addEventListener('shopify:section:load', onSectionLoad);
